module.exports = __webpack_public_path__ + "img/task-board-inquiry3.3cad8d80.png";